module.exports = __webpack_public_path__ + "img/7.dd6494f9.png";